import React from 'react';
import styles from './Breadcrumb.module.css';

const ChevronRightSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="9"
    viewBox="0 0 8 9"
    fill="none"
  >
    <path
      d="M2.5 1.16797L5.77731 4.50096L2.5 7.83464"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </svg>
);

const Breadcrumb = ({ children }) => {
  const validChildren = React.Children.toArray(children).filter(Boolean);
  
  return (
    <div className={styles.breadcrumb}>
      {validChildren.map((child, index) => {
        const isLast = index === validChildren.length - 1;
        
        return (
          <React.Fragment key={index}>
            <div className={isLast ? styles.breadcrumbTitle : styles.breadcrumbItem}>
              {React.cloneElement(child)}
            </div>
            
            {!isLast && (
              <span className={styles.breadcrumbSeparator}>
                <ChevronRightSvg />
              </span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

// Create a simple Item component
const Item = ({ children, ...props }) => (
  <span {...props}>{children}</span>
);

Breadcrumb.Item = Item;

export default Breadcrumb;